var _ = require('underscore');
module.exports = function(data){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='<div class="bubble-content">\n    ';
 if (data.close_button) { 
__p+='\n        <div class="bubble-control bubble-close glyph-close glyph-center" title="'+
((__t=( data.close_tooltip ))==null?'':_.escape(__t))+
'"></div>\n    ';
 } 
__p+='\n    ';
 if (data.title) { 
__p+='\n        <div class="bubble-title">'+
((__t=( data.title ))==null?'':_.escape(__t))+
'</div>\n    ';
 } 
__p+='\n    <div class="message-content"></div>\n    ';
 if (data.relativeTo && data.arrow) { 
__p+='\n        <div class="bubble-arrow"></div>\n    ';
 } 
__p+='\n</div>\n';
return __p;
};
